import {
    CmsBlockComponent as SourceCmsBlockComponent,
} from 'SourceComponent/CmsBlock/CmsBlock.component';
import React from 'react';
import './CmsBlock.override.style';
import Html from '@scandipwa/scandipwa/src/component/Html';

export class CmsBlockComponent extends SourceCmsBlockComponent {
    render() {
        const {
            cmsBlock: {
                identifier,
                content,
                disabled,
            },
            blockType,
        } = this.props;

        if (!content || disabled) {
            return null;
        }

        if (identifier === undefined) {
            return this.renderPlaceholder();
        }

        let data = content.replaceAll('&lt;', '<');
        let data2 = data.replaceAll('&gt;', '>');

        return (
            <div className={`CmsBlock-Wrapper CmsBlock-Wrapper_type_${blockType}`}>
                <Html content={data2} />
            </div>
        );
    }
}

export default CmsBlockComponent;
